import { Observable } from 'rxjs';


export interface WebSocketConfig {
  url: string;
  reconnectInterval?: number;
  reconnectAttempts?: number;
  verbose?: boolean;
}

/**
 * IDLE and FAILED are separate states on purpose. A single "closed" cannot say whether a
 * socket was never opened, was deliberately closed, or gave up — and a consumer that has to
 * reconstruct the difference ends up tracking flags to compensate.
 */
export enum WS_STATUS {
  /** No socket: never connected, or deliberately closed. Never a reason to warn the user. */
  IDLE = 'IDLE',
  CONNECTING = 'CONNECTING',
  OPEN = 'OPEN',
  RECONNECTING = 'RECONNECTING',
  /** Reconnect attempts exhausted. Set only by the channel itself, never by `close()`. */
  FAILED = 'FAILED'
}

/**
 * `TIn` and `TOut` are separate because a chat socket receives a union of message and error
 * frames but only ever sends one shape. No defaults: a channel whose frames are unnamed is
 * a channel nobody type-checks.
 */
export interface WsChannel<TIn, TOut> {
  messages$: Observable<TIn>;
  status$: Observable<WS_STATUS>;
  /** Returns false when the socket is not OPEN; the payload is dropped and the caller decides what to do. */
  send(payload: TOut): boolean;
  close(): void;
}
